import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import '../css/Register.css';
import Vas from '../Vas';
import { ExtendedButton,TextField,Icon,Loading } from 'component-lib';
import { CheckPassword } from 'utils-lib';
import { RequestAjaxClass, AccountsModel, PasswordModel } from 'models-lib';

class Activate  extends Component {

    constructor(props)
    {
        super(props);
        this.state = {};
        let token = decodeURIComponent(window.location.pathname.split('/activate/')[1]);
        this.state.Id = token;
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.AccountsModel = new AccountsModel([this],null,this.Request);
        this.PasswordModel = new PasswordModel([this],null,this.Request);

        //Hier die Angaben zur Vertragsanlage löschen, da der Dokumentenupload ebenfalls erfolgreich war
        localStorage.removeItem("CustomerId");
        localStorage.removeItem("ContractNUmber");
        localStorage.removeItem("ExecutingForm");
    }

    componentDidMount(){
      this.Request.setAuth(false);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setApiUrl(Vas.ApiUrl);

      this.PasswordModel.GetPaswordPolicy();

        this.setState({ requiredFields:[this.refs.newPassword, this.refs.retypePassword] },()=>{
            this.checkFields();
        });
    }

    componentDidUpdate(){
        this.checkFields();
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "PaswordPolicy"){
          let length = me.PasswordModel.PasswordLength;
          let countNumbers = me.PasswordModel.CountMinNumbers;
          let countLetters = me.PasswordModel.CountMinLetters;
          let countLowerCaseLetters = me.PasswordModel.CountMinLowerCaseLetters;
          let countUpperCaseLetters = me.PasswordModel.CountMinUpperCaseLetters;
          let countSpecialCharacters = me.PasswordModel.CountMinSpecialCharacters;

          let text = "display";
          let lengthL = "hide";
          let numbers = "hide";
          let letters = "hide";
          let lowerCaseLetters = "hide";
          let upperCaseLetters = "hide";
          let characters = "hide";
          if (length > 0){
              lengthL = "display";
              text = "hide";
          }
          if (countNumbers > 0){
              numbers = "display";
              text = "hide";
          }
          if (countLetters > 0){
              letters = "display";
              text = "hide";
          }
          if (countLowerCaseLetters > 0){
            lowerCaseLetters = "display";
            text = "hide";
          }
          if (countUpperCaseLetters > 0){
            upperCaseLetters = "display";
            text = "hide";
          }
          if (countSpecialCharacters > 0){
              characters = "display";
              text = "hide";
          }
          ReactDOM.render(
            <div>
              <div className={text}>-</div>
              <div className={lengthL}>{Vas.Resources.Labels["Least"]} {Vas.Resources.Labels["Length"]}: {length} {Vas.Resources.Labels["Chars"]}<br /></div>
              <div className={numbers}>{Vas.Resources.Labels["Least"]} {countNumbers} {Vas.Resources.Labels["AtLeastNumbers"]}<br /></div>
              <div className={letters}>{Vas.Resources.Labels["Least"]} {countLetters} {Vas.Resources.Labels["AtLeastChars"]}<br /></div>
              <div className={lowerCaseLetters}>{Vas.Resources.Labels["Least"]} {countLowerCaseLetters} {Vas.Resources.Labels["AtLeastLowerChars"]}<br /></div>
              <div className={upperCaseLetters}>{Vas.Resources.Labels["Least"]} {countUpperCaseLetters} {Vas.Resources.Labels["AtLeastUpperChars"]}<br /></div>
              <div className={characters}>{Vas.Resources.Labels["Least"]} {countSpecialCharacters} {Vas.Resources.Labels["AtLeastSymbols"]}<br /></div>
            </div>
          ,document.getElementById("policy"));
          me.setState({ PasswordModus:[length,countNumbers,countLetters,countLowerCaseLetters,countUpperCaseLetters,countSpecialCharacters] });
        }
        else if(observer === "ChangePassword"){
          Vas.clearLocalStorage();
          Vas.GetView('ActivateSuccess',null,false);
        }
      })
    }

    CheckPassword(){
        if (document.getElementById(this.refs.newPassword.props.Id).value.length > 0){
          
            if (CheckPassword.Check(document.getElementById(this.refs.newPassword.props.Id).value,this.state.PasswordModus) === true){
                this.refs.IconPassword.setState({ Name:"Done",Color:"green" });
            } else {
                this.refs.IconPassword.setState({ Name:"Warning",Color:"red" });
            }
        } else {
            this.refs.IconPassword.setState({ Name:"Warning",Color:"red" });
        }
        
        localStorage.setItem('Password', $('#password').val());
    }

    Activate()
    {
      if(localStorage.getItem('Password') != null || localStorage.getItem('Password') != ""){
        $('#retypePassword').val(localStorage.getItem('Password'));
      }

        ReactDOM.render(<Loading modal={true} />,document.getElementById('messageContainer'));
        localStorage.setItem('vas_token',this.state.Id);
        this.PasswordModel.ChangePassword("",$("#retypePassword").val());

    }

    checkFields(){
        $("#error2").removeClass().addClass("hide");
        if (this.state.requiredFields){
            let count=this.state.requiredFields.length;
            let filled=0;

            for (let i=0;i<this.state.requiredFields.length;i++){
                if (this.state.requiredFields[i]){
                    if (document.getElementById(this.state.requiredFields[i].props.Id).value.length>0){
                            filled++;
                    }
                }
            }
            if (filled < count){
                this.refs.btoActivate.setState({ usable:false });
            } else {

                $("#error2").removeClass().addClass("show");
                this.refs.btoActivate.setState({ usable:false })

                if(document.getElementById(this.refs.retypePassword.props.Id).value 
                  == document.getElementById(this.refs.newPassword.props.Id).value) {

                  $("#error2").removeClass().addClass("hide");

                  if(this.refs.IconPassword.state.Name == "Done") {
                    this.refs.btoActivate.setState({ usable:true });
                  } 
                } 

            }
        }
    }

    render()
    {

      $('#password').val(localStorage.getItem('Password'));

        return (
          <div className={"RegisterContainer"}>
            <div className={"form activateForm"}>
              <h2> { Vas.Resources.Titles["Activation"] }</h2>
              <div>
                <table Id={"ActivationTable"} style={{ width: "310px" }}>
                  <tbody>
                    <tr>
                      <td>
                        <TextField
                          AppURL={Vas.ApplicationUrl}
                          Id={"password"}
                          ref={"newPassword"}
                          Width={280}
                          Type={"password"}
                          Editable={true}
                          name="password" 
                          Label={Vas.Resources.Labels["Password"]}
                          Tooltip={Vas.Resources.Tooltips["Pwd"]}
                          OnBlur={(e,val)=>{ this.setState({ password: val });}} 
                          OnChange={()=>{this.CheckPassword();}} />
                        <Icon
                          ref={"IconPassword"}
                          Name={"Warning"}
                          Size={24}
                          Color={"red"}
                          Align={"left"} />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <TextField
                          AppURL={Vas.ApplicationUrl}
                          Id={"retypePassword"}
                          ref={"retypePassword"}
                          Width={300}
                          Type={"password"}
                          Editable={true}
                          name="retypePassword"
                          Label={Vas.Resources.Labels["RetypePassword"]}
                          Tooltip={Vas.Resources.Labels["RetypePassword"]}
                          OnChange={(e,val)=>{ this.setState( { retypePassword: val });}}  />
                      </td>
                    </tr>
                    <tr><td
                      id={"error2"}
                      className={"hide"}>{Vas.Resources.Labels["PasswordNotMatch"]}</td></tr>
                    <tr><td className={"ConfirmationLabel"}>{Vas.Resources.Labels["PasswordPolicy"]} </td></tr>
                    <tr><td
                      id={"policy"}
                      className={"ConfirmationLabel"}></td></tr>
                    <tr>
                      <td>
                        <div className={"LeftContainer"}>
                        <ExtendedButton
                          Usable={false}
                          Text={Vas.Resources.Labels["Activate"]}
                          ref={"btoActivate"}
                          Width={145}
                          OnClick={()=>{ this.Activate();}}
                          style={{ margin: 5 }}
                          Float={'left'} /></div>
                        <div className={"RightContainer"}>
                        <ExtendedButton
                          Usable={true}
                          Text={Vas.Resources.Labels["Cancel"]}
                          Width={145}
                          OnClick={()=>{ Vas.GetView("Home",null, false);}}
                          Float={'left'}
                          style={{ margin: 5 }} /></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
    }
}
export default Activate;
